<template>
    <div class="qr-dialog">
        <HLCardLayout class="pt-0" :scale="(isXsDevice)?0.75:(isXlDevice)?0.4:0.7" :loading="false" :minHeight="(isSmAndUpDevice)?'600':null" disableFooterPadding :horizontalMargin="true">
            <template #header-action>
                <!-- close btn -->
            </template>

            <template #menuTitle>
                <h3 class="three-dots px-sm-6 grey--text text--darken-3" :class="{'text-center':true}" :style="{'color': theme.textColor + '!important'}">{{$t('info_qr_checkin')}}</h3>
            </template>

            <!-- Content -->
            <template #content>
                <qrcode-stream v-if="!error" :camera="camera" :track="paintOutline" @init="onInit" @decode="onDecode">
                    <HLLoadingMaskOverlay v-show="isLoading"/>
                </qrcode-stream>

                <EspError v-else icon="mdi-alert-decagram" iconColor="red">
                    Fehler beim scan
                    <template #subTitle>

                        <p v-if="permissionError" :style="{'color': theme.btnTextColor}">
                            {{$t('permissionCamera')}}
                        </p>

                        <p v-else-if="noFrontCamera" :style="{'color': theme.btnTextColor}">
                            {{$t('camera_qr_error_NoFrontCamera')}}
                        </p>

                        <p v-else-if="noRearCamera" :style="{'color': theme.btnTextColor}">
                            {{$t('camera_qr_error_NoRearCamera')}}
                        </p>
                        <p v-else :style="{'color': theme.btnTextColor}">
                            {{$t(errorMessageKey)}}
                        </p>
                        <p class="text-caption" :style="{'color': theme.btnTextColor}">
                            {{errorName}}
                        </p>

                        <!--<v-btn
                        @click="requestForPermission"
                          large
                          block
                          depressed
                          rounded
                          color="green lighten-2"
                        >
                        Kamera Zugriff erlauben
                        <v-icon >mdi-check</v-icon>
                      </v-btn>-->
                    </template>
                </EspError>
            </template>

            <template #footer>
                <v-btn
                    @click="onCancel"
                    large
                    block
                    depressed
                    rounded
                    dark
                    :opacity="0.8"
                >
                    {{$t('close')}}
                </v-btn>
            </template>
        </HLCardLayout>
    </div>
</template>

<script>
import {QrcodeStream} from 'vue-qrcode-reader'
import {layoutMixin} from "../../utils/layout-mixin";
import HLCardLayout from "../../components/dashboard/HLCardLayout.vue";
import EspError from "../../components/animation/EspError.vue";
import HLLoadingMaskOverlay from "../../components/ui/HLLoadingMaskOverlay.vue";

// How long the scanner waits for the camera stream before it reports an error
const STREAM_LOAD_TIMEOUT_MS = 10000;

export default {
    mixins: [layoutMixin],
    components:{
        HLCardLayout,
        QrcodeStream,
        EspError,
        HLLoadingMaskOverlay
    },
    data(){
        return {
            camera: 'auto',
            error:false,
            errorName:'',
            permissionError:false,
            noRearCamera: false,
            noFrontCamera: false,
            isLoading:true
        }
    },

    computed: {
        // locale key of the current error, unknown error names fall back to the generic text
        errorMessageKey() {
            const key = `camera_qr_error_${this.errorName}`;
            return this.$te(key) ? key : 'camera_qr_error_';
        }
    },
    methods: {

        switchCamera () {
            this.isLoading = true;
            switch (this.camera) {
                case 'front':
                    this.camera = 'rear'
                    break
                case 'rear':
                case 'auto':
                    this.camera = 'front'
                    break
                default:this.camera = 'rear'
            }
        },

        async onInit (promise) {
            this.resetError();
            try {
                await this.withTimeout(promise, STREAM_LOAD_TIMEOUT_MS);
            } catch (error) {
                console.error(error);
                this.error=true;

                if(error){
                    this.errorName=error.name;

                    if (error.name === 'NotAllowedError') {
                        this.permissionError=true;
                    } else if (error.name === 'OverconstrainedError') {
                        const triedFrontCamera = this.camera === 'front'
                        const triedRearCamera = this.camera === 'rear'
                        this.noRearCamera = triedRearCamera
                        this.noFrontCamera = triedFrontCamera

                    }
                }
            } finally {
                this.isLoading = false;
            }
        },

        // Rejects with a StreamLoadTimeoutError when the camera is not ready in time; the library
        // itself never times out, so without this the scanner would show its loading mask forever.
        withTimeout(promise, ms) {
            const timeout = new Promise((resolve, reject) => {
                this.streamLoadTimer = window.setTimeout(() => {
                    const error = new Error(`camera stream not ready after ${ms} ms`);
                    error.name = 'StreamLoadTimeoutError';
                    reject(error);
                }, ms);
            });
            return Promise.race([promise, timeout]).finally(() => window.clearTimeout(this.streamLoadTimer));
        },

        paintOutline (detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints

                ctx.strokeStyle = "grey";

                ctx.beginPath();
                ctx.moveTo(firstPoint.x, firstPoint.y);
                for (const { x, y } of otherPoints) {
                    ctx.lineTo(x, y);
                }
                ctx.lineTo(firstPoint.x, firstPoint.y);
                ctx.closePath();
                ctx.stroke();
            }
        },

        onDecode(decodedString){
            this.onClose(decodedString);
            this.resetCameraToDecodeMultiple();
        },

        onCancel(){
            this.$emit('cancel');
        },

        onClose(data){
            // Handle QR code scan success
            console.log('QR Code scanned:', data);
            this.$emit('success', data);
        },

        requestForPermission(){
            return navigator.mediaDevices.getUserMedia({video: true})
        },
        async resetCameraToDecodeMultiple(){
            const preCamState=this.camera;
            this.camera = 'off';
            await this.timeout(500);
            this.camera = preCamState;
        },
        timeout (ms) {
            return new Promise(resolve => {
                window.setTimeout(resolve, ms)
            })
        },
        reset(){
            this.camera= 'auto';
        },
        resetError(){
            this.error=false;
            this.permissionError=false;
            this.errorName='';
        }
    },
    mounted() {
        this.reset();
    },
    beforeDestroy() {
        window.clearTimeout(this.streamLoadTimer);
    },
}
</script>

<style lang="scss">

</style>